export default {
  title: 'Obrigado por submeter as suas informações para receber pagamentos',
  description:
    'A revisão do Stripe pode demorar até 48 horas. Entretanto, pode continuar com os passos seguintes. Iremos informá-lo por email assim que as suas informações forem confirmadas.',
};
